export default "__VITE_ASSET__DpIbzdPE__"